import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Tabs,
  Tab,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Graphql
import getAllReservationQuery from './getAllReservationQuery.graphql';

// Component
import SideMenuTrips from '../../components/ManageListing/SideMenuTrips';
import Reservation from '../../components/Reservation';
import NoItem from '../../components/Reservation/NoItem';
import Loader from '../../components/Loader';
import CustomPagination from '../../components/CustomPagination';

import messages from '../../locale/messages';
import { debounce } from '../../helpers/debounce';
import history from '../../core/history';
import { withQuery } from '../../hoc/withGraphql';

import s from './TripsContainer.css';
import bt from '../../components/commonStyle.css';

const TripsContainer = (props) => {
  const {
    data: { loading, getAllReservation, refetch },
    userType,
    type,
    intl: { formatMessage }
  } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState('');

  useEffect(() => {
    setCurrentPage(1);
    refetch({ currentPage: 1, searchKey });
  }, [searchKey, type]);

  const paginationData = useCallback((page) => {
    setCurrentPage(page);
    refetch({ currentPage: page });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [refetch]);

  const handleSearchChange = debounce((value) => {
    setSearchKey(value);
    setCurrentPage(1);
    refetch({ searchKey: value, currentPage: 1 });
  });

  const handleSelect = useCallback((key) => {
    setCurrentPage(1);
    refetch({ currentPage: 1, searchKey });
    history.push(key === 1 ? '/trips/current' : '/trips/previous');
  }, [searchKey]);

  const handleClick = useCallback(() => {
    setCurrentPage(1);
    refetch({ currentPage: 1, searchKey });
  }, [searchKey]);

  return (
    <Grid fluid className={'dashBoardContainer'}>
      <Row>
        <Col xs={12}>
          <div className={'dashBoardListingGrid'}>
            <SideMenuTrips
              handleClick={handleClick}
              menuItemOne={formatMessage(messages.upcomingTrips)}
              menuItemTwo={formatMessage(messages.previousTrips)}
              linkOne={'/trips/current'}
              linkTwo={'/trips/previous'}
            />
            <div className={cx('commonListingBg', 'tripContainer')}>
              <Panel className={cx(s.panelHeader)}>
                <div className={cx(s.panelBorder, 'tabReservation')}>
                  <Tabs activeKey={type === 'current' ? 1 : 2} id="uncontrolled-tab-example" onSelect={handleSelect} className='commonListingTab'>
                    <Tab eventKey={1} title={<FormattedMessage {...messages.upcomingTab} />} />
                    <Tab eventKey={2} title={<FormattedMessage {...messages.previousTab} />} />
                  </Tabs>
                </div>
                <div className={s.listFlex}>
                  {getAllReservation?.totalCount > 0 && (
                    <div className={s.mobileWidth}>
                      <FormGroup className={s.noMargin}>
                        <FormControl
                          type="text"
                          placeholder={formatMessage(messages.searchTrips)}
                          onChange={(e) => handleSearchChange(e.target?.value)}
                          className={cx(s.formControlInput, s.guestReservationSearchInput, 'prefixIconInputRtl')}
                          value={searchKey}
                        />
                      </FormGroup>
                    </div>
                  )}
                </div>
                {loading && <Loader type="text" />}
                {!loading && getAllReservation?.reservationData?.length > 0 && (
                  <Reservation data={getAllReservation.reservationData} userType={userType} isTrip />
                )}
                {getAllReservation?.reservationData?.length > 0 && (
                  <CustomPagination
                    total={getAllReservation.count}
                    currentPage={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={5}
                    change={paginationData}
                    paginationLabel={formatMessage(messages.trips)}
                  />
                )}
                {!loading && getAllReservation?.reservationData?.length === 0 && (
                  <NoItem userType={userType} type={type} isTrip />
                )}
              </Panel>
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

TripsContainer.propTypes = {
  formatMessage: PropTypes.func,
  userType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getAllReservation: PropTypes.shape({
      count: PropTypes.number,
      reservationData: PropTypes.array
    }),
    refetch: PropTypes.func
  })
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  withQuery(getAllReservationQuery, {
    options: (props) => ({
      variables: {
        userType: props.userType,
        dateFilter: props.type,
        currentPage: 1
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(TripsContainer);
